module.exports = __webpack_public_path__ + "assets/src/placeholder_thumbnail.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/placeholder/placeholder_thumbnail.jpg
 ** module id = 181
 ** module chunks = 0
 **/